import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export function StickyMobileCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > window.innerHeight * 0.4);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.a
          data-testid="sticky-mobile-cta"
          href="#the-collection"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="md:hidden fixed inset-x-4 bottom-4 z-50 rounded-full bg-[#C8A96A] text-[#0C111C] py-4 text-center font-medium shadow-2xl"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Shop the collection · from €189 →
        </motion.a>
      )}
    </AnimatePresence>
  );
}
